(() => {
  const carouselSelector = '[id^="gp-carousel-product-list-carousel-"]';
  const cardSelector = '.gem-slider-item';
  const interactiveSelector = 'a, button, input, select, textarea, summary';
  const pointerStarts = new WeakMap();
  const observedCarousels = new WeakSet();

  const getProductUrl = (card) => {
    const product = card.querySelector('gp-product[gp-data]');

    if (!product) return null;

    try {
      return JSON.parse(product.getAttribute('gp-data')).productUrl || null;
    } catch (error) {
      return null;
    }
  };

  const prepareCard = (card) => {
    if (card.dataset.productLinkReady === 'true') return;

    const productUrl = getProductUrl(card);
    if (!productUrl) return;

    card.dataset.productLinkReady = 'true';
    card.dataset.productUrl = productUrl;
    card.setAttribute('role', 'link');
    card.setAttribute('tabindex', '0');
  };

  const observeCarousel = (carousel) => {
    if (observedCarousels.has(carousel)) return;

    observedCarousels.add(carousel);
    carousel.querySelectorAll(cardSelector).forEach(prepareCard);

    new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches?.(cardSelector)) prepareCard(node);
          node.querySelectorAll?.(cardSelector).forEach(prepareCard);
        });
      });
    }).observe(carousel, { childList: true, subtree: true });
  };

  const observeCarousels = () => {
    document.querySelectorAll(carouselSelector).forEach(observeCarousel);
  };

  document.addEventListener('pointerdown', (event) => {
    const card = event.target.closest(`${carouselSelector} ${cardSelector}`);
    if (!card) return;

    pointerStarts.set(card, { x: event.clientX, y: event.clientY });
  }, true);

  document.addEventListener('click', (event) => {
    const card = event.target.closest(`${carouselSelector} ${cardSelector}`);

    if (!card || event.target.closest(interactiveSelector)) return;

    const start = pointerStarts.get(card);
    const moved = start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 8;
    pointerStarts.delete(card);

    if (moved) return;

    const productUrl = card.dataset.productUrl || getProductUrl(card);
    if (productUrl) window.location.assign(productUrl);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const card = event.target.closest(`${carouselSelector} ${cardSelector}[data-product-url]`);
    if (!card || event.target.closest(interactiveSelector)) return;

    event.preventDefault();
    window.location.assign(card.dataset.productUrl);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCarousels, { once: true });
  } else {
    observeCarousels();
  }

  [250, 750, 1500, 3000].forEach((delay) => window.setTimeout(observeCarousels, delay));
})();
